import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { ProductForm } from './product-form'

export class SubscriptionWidget extends UcoastEl {
  static htmlSelector = 'subscription-widget'

  containers: NodeListOf<HTMLElement>
  sellingPlanSelected: HTMLInputElement | null
  tryButton: HTMLButtonElement | null
  onetimeInput: HTMLInputElement | null
  subscriptions: NodeListOf<HTMLInputElement>
  sellingPlans: NodeListOf<HTMLElement>
  sellingPlanContents: NodeListOf<HTMLElement>

  constructor() {
    super()
    this.containers = q.rl<HTMLElement>('.subscription-widget__container', this)
    this.tryButton = document.querySelector('.try-now-button')
    this.sellingPlanSelected = q.rs<HTMLInputElement>('.selling_plan_input', this)
    this.onetimeInput = q.rs<HTMLInputElement>('.subscription-widget__container .onetime', this)

    this.subscriptions = q.rl<HTMLInputElement>('.subscription-widget__container .subscription', this)
    this.sellingPlans = q.rl<HTMLElement>('.product-subscription__select .selling-plan', this)
    this.sellingPlanContents = q.rl<HTMLElement>('.subscription-widget__content', this)

    /* subscription change */
    this.subscriptions.forEach((subscriptionInput) => {
      subscriptionInput.addEventListener('change', () => {
        const container = subscriptionInput.closest<HTMLElement>('.subscription-widget__container')
        if (container) {
          const wrapper = q.rs<HTMLElement>('.subscription-widget__content', container)

          this.removeActive()
          this.syncSelectedContainers()
          wrapper?.classList.add('active')

          this.resetPlans()
          const isChecked = subscriptionInput.checked

          if (isChecked) {
            const plan = q.rs<HTMLElement>('.selling-plan', container)
            if (plan) this.setPlan(plan)
          } else if (this.sellingPlanSelected) {
            this.sellingPlanSelected.value = ''
            this.sellingPlanSelected.dispatchEvent(new Event('change', { bubbles: true }))
          }
        }
      })
    })

    /* one-time purchase */
    if (this.onetimeInput) {
      this.onetimeInput.addEventListener('change', () => {
        this.removeActive()
        this.syncSelectedContainers()
        this.resetPlans()
        const isChecked = this.onetimeInput?.checked

        if (isChecked && this.sellingPlanSelected) {
          this.sellingPlanSelected.value = ''
          this.sellingPlanSelected.dispatchEvent(new Event('change', { bubbles: true }))
        }
      })
    }

    /* selling plan click */
    this.sellingPlans.forEach((plan) => {
      plan.addEventListener('click', () => {
        this.resetPlans()
        this.setPlan(plan)
      })
    })

    if (this.tryButton) {
      this.tryButton.addEventListener('click', () => {
        const sellingPlanId = this.tryButton?.dataset.sellingPlanId
        if (sellingPlanId && this.sellingPlanSelected) {
          this.sellingPlanSelected.value = sellingPlanId
        }

        const productForm = q.rs<ProductForm>('product-form')
        productForm?.form.requestSubmit()
      })
    }

    this.syncSelectedContainers()
  }

  resetPlans(): void {
    this.sellingPlans.forEach((plan) => {
      plan.classList.remove('active')
    })
  }

  setPlan(plan: HTMLElement): void {
    plan.classList.add('active')

    const planId = plan.dataset.sellingPlanId

    if (this.sellingPlanSelected && planId) {
      this.sellingPlanSelected.value = planId
      this.sellingPlanSelected.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  removeActive(): void {
    this.sellingPlanContents.forEach((content) => {
      content.classList.remove('active')
    })
  }

  syncSelectedContainers(): void {
    this.containers.forEach((container) => {
      const input = q.os<HTMLInputElement>('.subscription_checkbox', container)
      container.classList.toggle('is-selected', Boolean(input?.checked))
    })
  }
}
